<template>
  <div class="live__container">
    <div class="live__title">
      <p>网络直播预约</p>
      <p>预约需要支付￥2500</p>
    </div>
    <div class="live__appointment-container">
      <template v-if="timeline">
        <div class="live-appointment__group-container">
          <div class="group__title">预约时间</div>
          <div class="group__main-body">
            <div class="body__date-container" v-for="(item, index) in timeline" :key="index">
              <div class="date__title">
                <strong>{{ index }}</strong
                >月
              </div>
              <div class="date__options">
                <div
                  class="option__item"
                  v-for="(date, d) in item"
                  :key="d"
                  @click="onSelected"
                  :data-pretime="date.pretime"
                  :data-preyear="date.preyear"
                  :class="{
                    disable: !date.is_choice,
                    selecetd: form.pretime === date.pretime && form.preyear === date.preyear
                  }"
                >
                  <strong>{{ date.pretime }}</strong> {{ !date.is_choice ? "已预约" : "无预约" }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="live-appointment__group-container">
          <div class="group__title">预约信息</div>
          <div class="group__main-body">
            <el-form class="appointment-form" :model="form" :rules="rules" ref="apForm">
              <el-form-item class="appointment-form__item" prop="name">
                <el-input
                  placeholder="您的姓名"
                  v-model="form.name"
                  class="appointment-form__input"
                ></el-input>
              </el-form-item>
              <el-form-item class="appointment-form__item" prop="phone">
                <el-input
                  placeholder="联系电话"
                  v-model="form.phone"
                  class="appointment-form__input"
                ></el-input>
              </el-form-item>
              <el-form-item class="appointment-form__item" prop="sharetitle">
                <el-input
                  placeholder="您打算分享的主题"
                  v-model="form.sharetitle"
                  class="appointment-form__input"
                ></el-input>
              </el-form-item>
              <el-form-item class="appointment-form__item" prop="remarks">
                <el-input
                  placeholder="备注"
                  v-model="form.remarks"
                  class="appointment-form__input"
                ></el-input>
              </el-form-item>
              <el-form-item class="appointment-form__item --submit">
                <el-button
                  type="primary"
                  @click="onSubmit"
                  class="appointment-form__button"
                  :loading="loading.submit"
                  >确认预约</el-button
                >
              </el-form-item>
            </el-form>
          </div>
        </div>
      </template>
    </div>
    <pay-qrcode
      :visible.sync="pay.visible"
      :body="pay.desc"
      :price="pay.price"
      @afterPay="afterPay"
    ></pay-qrcode>
  </div>
</template>

<script>
import PayQrcode from '@/pages/common/payQrcode.vue';

export default {
  components: {
    PayQrcode,
  },
  props: {
    timeline: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      loading: {
        submit: false,
      },
      form: {
        name: '',
        phone: '',
        sharetitle: '',
        remarks: '',
        preyear: '',
        pretime: '',
        is_pay: 1,
      },
      rules: {
        name: [
          {
            required: true,
            message: '请填写您的姓名',
            trigger: 'blur',
          },
        ],
        phone: [
          {
            required: true,
            message: '请填写您的联系电话',
            trigger: 'blur',
          },
          {
            pattern: /^0{0,1}(1)[0-9]{10}$/,
            message: '手机号码格式不正确',
            trigger: 'blur',
          },
        ],
        sharetitle: [
          {
            required: true,
            message: '请填写您打算分享的主题',
            trigger: 'blur',
          },
        ],
      },
      pay: {
        visible: false,
        desc: '',
        price: 0,
      },
    };
  },
  methods: {
    onSelected(e) {
      const data = e.currentTarget.dataset;
      this.form.preyear = data.preyear;
      this.form.pretime = data.pretime;
    },
    onSubmit() {
      const that = this;
      that.$refs.apForm.validate((valid) => {
        let re = valid;
        if (that.form.preyear === '' || that.form.pretime === '') {
          that.$message({
            type: 'error',
            message: '请选择预约时间',
          });
          console.warn('请选择预约时间');
          re = false;
          // Promise.reject(new Error('请选择预约时间'));
        }
        if (re) {
          // 去支付
          this.pay = {
            visible: true,
            desc: '预约直播',
            price: 2500,
          };
        }
      });
    },
    afterPay(ordernum) {
      const that = this;
      that.form.loading = true;
      that.form.ordernum = ordernum;
      that.$http
        .post('html/Propaganda/addPrelive', that.form)
        .then(() => {
          that.$message({
            type: 'success',
            message: '预约成功',
          });
          that.timeline.map((item) => {
            const temp = item.map((d) => {
              const dTemp = d;
              if (dTemp.preyear === that.form.preyear && that.form.pretime === dTemp.pretime) {
                dTemp.is_choice = false;
              }
              return dTemp;
            });
            return temp;
          });
        })
        .finally(() => {
          that.form.loading = false;
          that.$refs.apForm.resetFields();
        });
    },
  },
};
</script>

<style></style>
